(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('AdminExaminersController', AdminExaminersController);

    function AdminExaminersController($scope, $state, $stateParams, $translate, logger, config, modalDialogService, dataService, allExaminerClusterActions) {
        var vm = this;
        
        vm.allExaminerClusterActions = allExaminerClusterActions;
        vm.deleteAssignments = deleteAssignments;
        vm.exportAssignments = exportAssignments;
        vm.getId = getId;
        vm.getTypeName = getTypeName;
        vm.identitySelected = identitySelected;
        vm.importAssignments = importAssignments;
        vm.isAssigned = isAssigned;
        vm.isChecked = isChecked;
        vm.saveActivitySettings = saveActivitySettings;
        vm.toggleAll = toggleAll;
        
        $scope.$watch('vm.identity', function (n, o) {
            if (o === n) return;

            vm.selectedClusterActionId = null;

            _loadAssignedClusterActions();
        });

        $scope.$watch('vm.selectedClusterActionId', function (n, o) {
            if (o === n) return;

            vm.skillActivitySettings = null;

            if (vm.selectedClusterActionId === null) return;

            dataService.getExaminerSkillActivitySettings(vm.selectedClusterActionId, vm.identity.idString)
                .then(result => {
                    vm.skillActivitySettings = result;
                });
        });

        function _findClusterAction(array, actionId) {
            array = array || [];
            return _.find(array, function (item) { return item.actionId === actionId; });
        }

        function _loadAssignedClusterActions() {
            vm.skillActivitySettings = null;
            vm.assignedClusterActions = [];

            dataService.getExaminerClusterActions(vm.identity.idString)
                .then(result => {
                    vm.assignedClusterActions = result;
                });
        }

        function deleteAssignments() {
            var msg = $translate.instant('confirm_delete_examiner_assignments') + '<br/><br/>' + vm.identity.displayName;
            return modalDialogService.confirmDelete('delete_examiner_assignments', msg, () => {
                return dataService.deleteExaminer(vm.identity.idString).then(() => {
                    logger.success('successfully_deleted');

                    vm.selectedClusterActionId = null;
                    vm.assignedClusterActions = [];
                });
            });
        }

        function exportAssignments() {
            return modalDialogService.openImportExportExaminerAssignmentsDialog(vm.identity, false).then(result => {
                logger.success('successfully_saved');
            });
        }

        function getId() {
            var id = '';
            for (var i = 0; i < arguments.length; i++) {
                if (id > 0) id += '_';
                id += arguments[i];
            }
            return id;
        }

        function getTypeName(type) {
            switch (type.toLowerCase()) {
                case "classical":
                    return $translate.instant("classical_theory_lesson");
                case "skillslabtraining":
                    return $translate.instant("skillslab_training");
                case "trainingonthejob":
                    return $translate.instant("training_on_the_job");
                case "writtentest":
                    return $translate.instant("written_test");
                case "practical":
                    return $translate.instant("practice_test");
                case "skillslabtest":
                    return $translate.instant("skillslab_test");
                case "peerassessment":
                    return $translate.instant("peer_assessment");
            }
        }
        
        function identitySelected(identity) {
            vm.identity = identity;
        }

        function importAssignments() {
            return modalDialogService.openImportExportExaminerAssignmentsDialog(vm.identity, true).then(result => {
                logger.success('successfully_saved');
                _loadAssignedClusterActions();
            });
        }

        function isAssigned(ca) {
            return _findClusterAction(vm.assignedClusterActions, ca.actionId) !== undefined;
        }

        function isChecked(item) {
            for (var i = 0; i < item.activitySettings.length; i++) {
                var setting = item.activitySettings[i];
                if (setting.isExaminer === false) return false;
            }
            return true;
        }
        
        function saveActivitySettings() {
            
            return dataService.setExaminerSkillActivitySettings(vm.selectedClusterActionId, vm.identity.idString, vm.skillActivitySettings.activityTypeSettings)
                .then(result => {

                    vm.skillActivitySettings = result;

                    var isAssigned = false;
                    for (var i = 0; i < result.activityTypeSettings.length; i++) {
                        isAssigned = _.find(result.activityTypeSettings[i].activitySettings, function (item) { return item.isExaminer === true; }) !== undefined;
                        if (isAssigned) break;
                    }

                    if (isAssigned) {
                        var ca = _findClusterAction(vm.assignedClusterActions, vm.selectedClusterActionId);
                        if (ca === undefined) {
                            ca = _findClusterAction(allExaminerClusterActions, vm.selectedClusterActionId);
                            vm.assignedClusterActions.push(ca);
                        }
                    }
                    else {
                        var ca = _findClusterAction(vm.assignedClusterActions, vm.selectedClusterActionId);
                        if (ca !== undefined) {
                            var idx = vm.assignedClusterActions.indexOf(ca);
                            vm.assignedClusterActions.splice(idx, 1);
                        }
                    }

                    logger.success('successfully_saved');
                });
        }

        function toggleAll(item) {
            for (var i = 0; i < item.activitySettings.length; i++) {
                item.activitySettings[i].isExaminer = item.all;
            }
        }
    }       
})();